export default {
      id: "bottom-arr-usage",
      viewBox: "0 0 15 9",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#bottom-arr",
      toString: function () {
        return this.url;
      }
    }